var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliver3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3205.9 2693.8h-1912.9c-43.426-192.15-194.91-343.46-387.11-386.61v-1721.9c0-167.68-136.07-304.09-303.36-304.09h-190.86c-62.102 0-112.5 50.398-112.5 112.5s50.398 112.5 112.5 112.5h190.86c43.199 0 78.355 35.492 78.355 79.086v1722c-228.21 51.582-399.32 255.6-399.32 499.16 0 282.43 229.73 512.16 512.16 512.16 243.84 0 448.03-171.39 499.39-399.94h1912.8c62.102 0 112.5-50.398 112.5-112.5 0-62.102-50.398-112.5-112.5-112.5zm-2412.2 399.94c-158.34 0-287.16-128.81-287.16-287.16s128.81-287.1 287.16-287.1 287.16 128.81 287.16 287.1-128.87 287.16-287.16 287.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2081.2 450h225v562.5h-225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2925 450h-393.75v675c0 62.102-50.398 112.5-112.5 112.5h-450c-62.102 0-112.5-50.398-112.5-112.5v-675h-450c-124.09 0-225 100.91-225 225v1518.8c0 124.09 100.91 225 225 225h1518.8c124.09 0 225-100.91 225-225v-1518.8c0-124.09-100.91-225-225-225zm-1090.1 1608h-180.39c-62.102 0-112.5-50.398-112.5-112.5 0-62.102 50.398-112.5 112.5-112.5h180.39c62.102 0 112.5 50.398 112.5 112.5 0 62.102-50.398 112.5-112.5 112.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliver3);
export default __webpack_public_path__ + "static/media/deliver3.97f68858d22915d50c1428fae1f54e4f.svg";
export { ForwardRef as ReactComponent };